import { makeChartComp } from '../../util/makeChartComp';
var MixChart = makeChartComp('Mix');
export default MixChart;
